import { io, type Socket } from 'socket.io-client';

import type {
  MatchUpdatedDto,
  MessageDto,
  MessagesReadDto,
  PresenceDto,
  TypingDto,
  ChatAccessDto,
} from '@/src/entities/chats/api/dto';
import { refreshSession } from '@/src/shared/api/axios';
import { API_ORIGIN } from '@/src/shared/config/api';
import { isAccessTokenExpired } from '@/src/shared/lib/access-token';
import { getAccessToken } from '@/src/shared/model/auth-store';

type ServerEvents = {
  'message:created': (message: MessageDto) => void;
  'messages:read': (payload: MessagesReadDto) => void;
  'match:updated': (payload: MatchUpdatedDto) => void;
  'presence:updated': (payload: PresenceDto) => void;
  'typing:updated': (payload: TypingDto) => void;
  'message:updated': (message: MessageDto) => void;
  'chat:access': (payload: ChatAccessDto) => void;
};

type ClientEvents = {
  'typing:update': (payload: { chatId: string; isTyping: boolean }) => void;
};

async function resolveSocketToken() {
  const token = getAccessToken();

  if (token && !isAccessTokenExpired(token)) {
    return token;
  }

  try {
    const session = await refreshSession();
    return session.accessToken;
  } catch {
    return '';
  }
}

export const chatSocket: Socket<ServerEvents, ClientEvents> = io(API_ORIGIN, {
  autoConnect: false,
  auth: (callback) => {
    void resolveSocketToken().then((token) => {
      callback({ token });
    });
  },
});
